<template>
    <div class="item">
        <el-dropdown >
            <el-badge :max="99" :value="MessageCount" class="item">
                <i class="iconfont iconbell fxn-text-light-gray"></i>
            </el-badge>
            <el-dropdown-menu slot="dropdown">
                <div class="fxn-header-message">
                    <div class="fxn-header-message-title">新消息<span v-if="MessageCount != ''">({{MessageCount}})</span></div>
                    <ul>
                        <li class="fxn-message-list" v-for="(item,index) in MessageRing.msg" :key="index" @click="OpenLink(item.id,item.type,true)">
                            <div class="title fxn-ellipsis-1">{{item.title}}</div>
                            <div class="content fxn-ellipsis-1">{{item.send_time | dateTime(1)}}</div>
                        </li>
                    </ul>
                    <div class="fxn-header-message-more" @click="toMore">查看更多</div>
                </div>
            </el-dropdown-menu>
        </el-dropdown>

        <!-- 弹窗 -->
        <div class="fxn-dialog" v-show="MessageShow">
            <div class="fxn-dialog-header">
                <span v-if="MessageBox.count == 1">{{CahngeType(MessageBox.msg[0].type)}}</span>
                <span v-if="MessageBox.count > 1">消息通知</span>
                <i class="el-icon-close" @click="MessageShow = false"></i>
            </div>
            <div class="fxn-header-body" v-if="MessageBox.count == 1">
                <span v-html="MessageBox.msg[0].content"></span>
            </div>
            <div class="fxn-header-body" v-if="MessageBox.count > 1">
                您有<span class="fxn-text-default">{{MessageBox.count}}条</span>未读消息，请及时处理！
            </div>
            <div class="fxn-header-footer">
                <el-button size="medium" @click="MessageShow = false">关闭</el-button>
                <el-button size="medium" type="primary" v-if="MessageBox.count == 1" @click="OpenLink(MessageBox.msg[0].id,MessageBox.msg[0].type)">查看</el-button>
                <el-button size="medium" type="primary" v-if="MessageBox.count > 1" @click="toMore">查看</el-button>
            </div>
        </div>
        <!-- 弹窗 End -->

        <!-- 提醒 -->
        <div class="el-message el-message--success" v-show="TextShow">
            <i class="el-message__icon el-icon-success"></i>
            <div class="el-message__content fxn-ellipsis-1" v-for="(item,index) in Messagetext.msg" :key="index" @click="toText(item.id)">
                {{item.title}}
            </div> 
            <i class="el-message__closeBtn el-icon-close" @click="TextShow = false"></i>           
        </div>
        <!-- 提醒 End -->
    </div>
</template>

<script>
    let ws = '';
    export default {
        data(){
            return{
                MessageShow: false,             //消息通知窗口
                WithdrawalShow: false,          //退案窗口
                TextShow: false,                //提醒窗口

                MessageCount: '',               //铃--数量
                MessageRing: [],                //铃

                MessageBoxCount: '',            //弹窗--数量
                MessageBox: [],                 //弹窗
                Messagetext: [],                //提醒
            }
        },
        methods:{

            //获取消息中心
            getMessage(){
                let _this = this
                ws = new WebSocket(this.WebSocketUrl);
                let user = JSON.parse(localStorage.getItem('user'));
                if (user) {
                    _this.member_id = user.memberInfo.id
                }
                ws.onopen = function() {
                    ws.send('{"cmd":"member_call_message_send","member_id":"'+ _this.member_id +'"}');
                };
                ws.onmessage = function(e) {
                    if(e.data != 0){
                        let Message = JSON.parse(e.data);
                        console.log(Message)
                        _this.MessageRing = Message.ring;     //铃
                        _this.MessageCount = Message.ring.count;
                        _this.MessageBox = Message.box;       //弹窗
                        _this.Messagetext = Message.text;     //提醒

                        //判断弹窗
                        if(_this.MessageBox.count > 0){
                            _this.MessageShow = true;
                        }else{
                            _this.MessageShow = false;
                        }

                        //判断提醒消息
                        if(_this.Messagetext.count > 0){
                            _this.TextShow = true;
                        }else{
                            _this.TextShow = false;
                        }
                    }else{
                        _this.MessageRing = [];
                        _this.MessageCount = '0';
                        _this.TextShow = false;
                    }
                };
                ws.onclose = function (event) {
                    _this.callMessage();
                }
            },

            //当检测到消息中心长链接关闭,重新连接
            callMessage(){
                this.getMessage();
            },

            //查看更多消息
            toMore(){
                this.$router.push({ path: '/MessageCentre' });
            },

            //查看提醒内容
            toText(id){
                this.TextShow = false;
                this.$router.push({ path: '/MessageDetail', query: {id : id} });
            },

            //跳转
            OpenLink(id,type,mold){
                this.MessageShow = false;
                if(type == 7 && mold){
                    this.$router.push({ path: '/MyWorkOrder' });
                }else if(type == 7){
                    this.$router.push({ path: '/MessageCentre', query: {type : type} });
                }else{
                    window.open('index.html#/MessageDetail?id=' + id + '&type=' + type)
                }
                
            },

            //转换格式
            CahngeType(type){
                if(type == 1){
                    return '系统服务通知'
                }else if(type == 2){
                    return '版本更新升级'
                }else if(type == 3){
                    return '活动消息'
                }else if(type == 4){
                    return '退案提醒'
                }else if(type == 5){
                    return '承诺还款'
                }else if(type == 6){
                    return '另约时间'
                }else if(type == 7){
                    return '工单反馈'
                }else if(type == 8){
                    return '坐席余额提醒'
                }else if(type == 9){
                    return '短信余额提醒'
                }else if(type == 10){
                    return '律师函余额提醒'
                }
            }
        },
        mounted(){
           this.getMessage();
        }
    }
</script>

<style scoped>
    
</style>


// WEBPACK FOOTER //
// src/components/Message.vue